module.exports = "<div dynamicPage>\r\n  </div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/views/login/login.component.html
// module id = ./src/app/views/login/login.component.html
// module chunks = main